import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@transient()
@autoinject
export class ChangeInspectorConfirmationDialog {

    onProceed: () => Promise<void>;
    onCancel: () => void;

    constructor(private dialogClientService: DialogClientService) {

    }

    activate(model: { onProceed: () => Promise<void>, onCancel: () => void })
    {
        this.onProceed = model.onProceed;
        this.onCancel = model.onCancel;
    }

    close() {
        this.dialogClientService.hide(true);
    }

    async proceed()
    {
        if(this.onProceed)
            await this.onProceed();

        this.close();
    }

    cancel()
    {
        if(this.onCancel)
            this.onCancel();

        this.close();
    }
}